Vue.component('AuditLogIndexComponent', require('./components/AuditLogIndexComponent').default);
Vue.component('AuditLogGetComponent', require('./components/AuditLogGetComponent').default);
